import {
  INITIAL_INTAKE_SOURCE,
  type IntakeSource
} from "../cubeDataTable/utils/intakeUtils";

/**
 * The live control-bar state. Which rows the grid shows and how they sort
 * is not here — that is a view's row selection (``ViewRows``), owned by the
 * Views picker, because a preset and a saved view set it the same way.
 */
export interface ForecastTableControlValues {
  calendarView: "Inv 454" | "Fin greg" | "Greg cal year";

  weekLabels: "Calendar" | "Fiscal";

  timePeriod: "WK" | "MO" | "QTR" | "HY" | "PTG";

  /**
   * Entry mode. ``IDX`` and ``+/- Var`` are the same relative flow against
   * the planning year's reference data: an index of 126 and a variance of
   * +26 % both land 126 units on an LY of 100. ``SH%`` is display-only.
   */
  planBy: "ABS" | "IDX" | "+/- Var" | "SH%";

  intake: IntakeSource;

  gridStyleGrouping: "KPI" | "KPI Family" | "None";

  planningYear: string;
}

/**
 * Whether ``view`` is the one view whose rows carry edits. The gregorian
 * views are derived, read-only compatibility views.
 */
export function isEditableCalendarView(
  view: ForecastTableControlValues["calendarView"]
): boolean {
  return view === "Inv 454";
}

export interface ForecastTableControlOptions {
  calendarView: ForecastTableControlValues["calendarView"][];
  weekLabels: ForecastTableControlValues["weekLabels"][];
  timePeriod: ForecastTableControlValues["timePeriod"][];
  planBy: ForecastTableControlValues["planBy"][];
  gridStyleGrouping: ForecastTableControlValues["gridStyleGrouping"][];
  planningYear: { label: string; value: string }[];
}

export const DEFAULT_FORECAST_TABLE_CONTROL_OPTIONS: ForecastTableControlOptions =
  {
    calendarView: ["Inv 454", "Fin greg", "Greg cal year"],
    weekLabels: ["Calendar", "Fiscal"],
    timePeriod: ["WK", "MO", "QTR", "HY", "PTG"],
    planBy: ["ABS", "IDX", "+/- Var", "SH%"],
    gridStyleGrouping: ["KPI", "KPI Family", "None"],
    planningYear: []
  };

export const DEFAULT_FORECAST_TABLE_CONTROL_VALUES: ForecastTableControlValues =
  {
    calendarView: "Inv 454",
    weekLabels: "Calendar",
    timePeriod: "WK",
    planBy: "ABS",
    intake: INITIAL_INTAKE_SOURCE,
    gridStyleGrouping: "KPI",
    // No fiscal year is known until the metadata lands. The seeding effects
    // match on this to tell an untouched control from a planner's own pick.
    planningYear: ""
  };
